import { DatePicker, Form, Radio, Row, Select } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { dateToString, isBeforeDate } from 'utils/utilsSFS';
import { AuthContext } from 'components/Auth/Auth';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import InputCurrency from 'components/InputCurrency';
import OfferInput from 'pages/Configuration/Management/ParametersFiltering/OfferInput';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import WizardSteps from '../../../components/theme_components/WizardSteps';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import moment from 'moment';
import { toCurrency } from 'utils/utils';

export type TabActivityProps = {
  form: FormInstance;
  onDone: any;
  onCancel: any;
  loading: boolean;
  dataInput?: any;
  brand?:any;
};

const TabActivity = ({
  form,
  onDone,
  onCancel,
  loading,
  dataInput,
  brand,
}: TabActivityProps) => {
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [offerId, setOfferId] = useState<string | undefined>(undefined);

  const checkForExistingActivity = (prcode: string) => {
    const existingActivity = dataInput?.find(
      (activity: { authDetail: { prcode: string }[] }) =>
        activity.authDetail[0].prcode === prcode
    );
    return existingActivity;
  };
  useEffect(() => {
    form.setFieldsValue({
      event: 'TabEvAuthorizationSFS',
      offerid: offerId,
      startdate: moment(),
      enddate: moment().add('days', 365),
      flagtolerance: 'no',
      flagexcludpermeabilitypm: false,
      creditcontrol: 'SYSTEM'
    });
  }, []);
  const [current, setCurrent] = useState(0);
  const next = () => {
    if (current === 0) {
      const existingActivity = checkForExistingActivity(
        form.getFieldValue('prcode')
      );
      if (existingActivity) {
        setModalVisible(true);
        return;
      }
    }
    form.validateFields().then(() => {
      setCurrent(current + 1);
    });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const done = () => {
    form.validateFields().then(() => {
      onDone();
    });
    // form.submit();
  };
  const cancel = () => {
    onCancel();
    // form.submit();
  };

  const steps = [
    { stepcomcode: 'Activité', key: 'step1' },
    { stepcomcode: 'Normal limit', key: 'step2' },
    { stepcomcode: 'MPEA', key: 'step3' },
    { stepcomcode: 'Options', key: 'step4' },
    { stepcomcode: 'Recap', key: 'step5' },
  ];

  const [prcode, setprcode] = useState<string>();

  const stepsContent = {
    step1: (
      <>
        <FormInput
          name="prcode"
          className="form-item mb-7"
          layout="vertical"
          rules={[{ required: current == 0 }]}
        >
          <ProductInput
            className="no-border-radius"
            onSelected={(value) => {
              setprcode(value);
              form.setFieldsValue({ offercode: undefined });
            }}
          />
        </FormInput>
        <FormInput
          name="flagretailer"
          className="form-item mb-7"
          layout="vertical"
          rules={[{ required: current == 0 }]}
        >
          <Select
            style={{ width: 120 }}
            options={[
              { value: 'RETAILER', label: 'RETAILER' },
              { value: 'DEALER', label: 'DEALER' },
            ]}
          />
        </FormInput>
        {/* Track offerid in a separate state */}
        <FormInput
          name="offercode"
          className="form-item mb-7"
          layout="vertical"
          rules={[{ required: current == 0 }]}
        >
          <OfferInput
            params={{
              prcode: String(prcode),
              mgid: Number(localStorage.getItem('mgid')),
              brand: brand??'',
            }}
            allData
            onChange={(value: any) => {
              // Set offerid in a separate state variable
              setOfferId(value);
              form.setFieldsValue({ offerid: value });
            }}
          />
        </FormInput>
      </>
    ),
    step2: (
      <FormInput
        name="authamount"
        layout="vertical"
        rules={[{ required: current == 1 }]}
      >
        <InputCurrency
          currcode={form?.getFieldValue('currcode')}
          className="form-item mb-7 no-border-radius ant-input"
        />
      </FormInput>
    ),
    step3: (
      <FormInput
        name="authcalculatedamount"
        layout="vertical"
        rules={[
          {
            required: current == 2,
            validator: (_, value) => {
              if (current == 2) {
                if (form.getFieldValue('authamount') <= value) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(
                    new Error(
                      'le montant de la MPEA doit être superieur ou égale au montant du normal limit '
                    )
                  );
                }
              } else {
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        <InputCurrency
          currcode={form?.getFieldValue('currcode')}
          className="form-item mb-7 no-border-radius ant-input"
        />
      </FormInput>
    ),
    step4: (
      <>
        <FormInput
          name="startdate"
          className="form-item mb-7"
          layout="vertical"
          extra="JJ-MM-AAAA"
          rules={[{ required: current == 3 }]}
        >
          <DatePicker
            className="form-item no-border-radius"
            defaultValue={moment(new Date(), 'DD-MM-YYYY')}
            disabledDate={(d) => isBeforeDate(d, moment())}
            onChange={(date) => {
              let newEndDate = dateToString(date);
              form.setFieldValue(
                'enddate',
                moment(newEndDate).add('days', 365)
              );
            }}
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
          />
        </FormInput>
        <FormInput
          name="enddate"
          className="form-item mb-7"
          layout="vertical"
          extra="JJ-MM-AAAA"
          rules={[{ required: current == 3 }]}
        >
          <DatePicker
            className="form-item no-border-radius"
            disabledDate={(d) =>
              isBeforeDate(d, moment(form.getFieldValue('startdate')))
            }
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
          />
        </FormInput>
        <FormInput
          name="flagtolerance"
          className="form-item no-border-radius"
          labelAlign="left"
        >
          <Radio.Group className="text-right ut-radio-group" defaultValue='no'>
            <Radio value="yes"> <GetLabel label="yes" /> </Radio>
            <Radio value="no" defaultChecked> <GetLabel label="no" /></Radio>
          </Radio.Group>
        </FormInput>
        <FormInput
          name="flagexcludpermeabilitypm"
          className="form-item no-border-radius"
          labelAlign="left"
          initialValue={false}
        >
          <Radio.Group className="text-right ut-radio-group">
            <Radio value>
              {' '}
              <GetLabel label="yes" />{' '}
            </Radio>
            <Radio value={false} defaultChecked>
              {' '}
              <GetLabel label="no" />{' '}
            </Radio>
          </Radio.Group>
        </FormInput>
        <FormInput
          name="creditcontrol"
          className="form-item no-border-radius"
          labelAlign="left"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Radio.Group
            defaultValue={'SYSTEM'}
            className="ut-radio-group ant-radio-group-flex-end"
          >
            <Radio value="NONE">
              {' '}
              <GetLabel label="none" />{' '}
            </Radio>
            <Radio value="SYSTEM" defaultChecked>
              {' '}
              <GetLabel label="systematic" />{' '}
            </Radio>
            <Radio value="BLOCKED">
              {' '}
              <GetLabel label="blocked" />{' '}
            </Radio>
          </Radio.Group>
        </FormInput>
      </>
    ),
    step5:(
      <div
          className="recap-section"
          style={{ marginTop: '-17px', marginLeft: '-6px' }}
        >
          <GetLabel
            label="recap"
            className="font-size-20 gray-color"
            style={{ marginBottom: 24 }}
          />

          <div style={{ marginTop: '24px', marginBottom: 10 }}>
            <p style={{ marginBottom: 14 }}>
              <GetLabel label="prcode" className="font-size-16 mr-2" />{' '}
              <span style={{ fontWeight: 500 }}>
                {form.getFieldValue('prcode')}
              </span>
            </p>
            {/* <p style={{ marginBottom: 14 }}>
              <GetLabel
                label="offerid"
                className="font-size-16 mr-2"
              />
              <span style={{ fontWeight: 500 }}>
                {form.getFieldValue('offerid')}
              </span>
            </p> */}
            <p style={{ marginBottom: 14 }}>
              <GetLabel label="flagretailer" className="font-size-16 mr-2" />
              <span style={{ fontWeight: 500 }}>
                {form.getFieldValue('flagretailer')}
              </span>
            </p>
            <p style={{ marginBottom: 14 }}>
              <GetLabel label="authamount" className="font-size-16 mr-2" />{' '}
              <span style={{ fontWeight: 500 }}>
                {toCurrency(form.getFieldValue('authamount'))}
              </span>
            </p>
            <p style={{ marginBottom: 14 }}>
              <GetLabel
                label="authcalculatedamount"
                className="font-size-16 mr-2"
              />
              <span style={{ fontWeight: 500 }}>
                {toCurrency(form.getFieldValue('authcalculatedamount'))}
              </span>
            </p>
            <p style={{ marginBottom: 14 }}>
              <GetLabel label="startdate" className="font-size-16 mr-2" />{' '}
              <span style={{ fontWeight: 500 }}>
                {moment(form.getFieldValue('startdate')).format('DD/MM/YYYY')}
              </span>
            </p>
            <p style={{ marginBottom: 14 }}>
              <GetLabel label="enddate" className="font-size-16 mr-2" />{' '}
              <span style={{ fontWeight: 500 }}>
                {moment(form.getFieldValue('enddate')).format('DD/MM/YYYY')}
              </span>
            </p>

            <p style={{ marginBottom: 14 }}>
              <GetLabel label="flagtolerance" className="font-size-16 mr-2" />{' '}
              <span style={{ fontWeight: 500 }}>
                <GetLabel label={form.getFieldValue('flagtolerance') === "yes" ? "yes" : "no"} />
              </span>
            </p>

            <p style={{ marginBottom: 14 }}>
              <GetLabel
                label="flagexcludpermeabilitypm"
                className="font-size-16 mr-2"
              />{' '}
              <span style={{ fontWeight: 500 }}>
                {form.getFieldValue('flagexcludpermeabilitypm') ? (
                  <GetLabel label="yes" />
                ) : (
                  <GetLabel label="no" />
                )}
              </span>
            </p>

            <p style={{ marginBottom: 14 }}>
              <GetLabel label="creditcontrol" className="font-size-16 " />{' '}
              <span style={{ fontWeight: 500 }}>
                <GetLabel
                  label={
                    form.getFieldValue('creditcontrol') === 'NONE'
                      ? 'None'
                      : form.getFieldValue('creditcontrol') === 'SYSTEM'
                      ? 'System'
                      : 'Blocked'
                  }
                />
              </span>
            </p>
          </div>

        
        </div>
    )
  };
  const totalSteps = steps.length + 1;
  return (
    <Form form={form}>
      {/* <Title level={3} comcode={'addlimit'} className="mt-5" /> */}
      
        <WizardSteps
          steps={steps}
          stepsContent={stepsContent}
          direction="horizontal"
          currentStep={current}
          className="my-custom-class"
          onNext={next}
          onPrev={prev}
          onDone={done}
          onCancel={cancel}
          nextComcode="Next"
          prevComcode={current === 0 ? 'Réinitialiser' : 'Previous'}
          doneComcode="Done"
          hideCancelIcon
          classNameProp="nocontainer"
          isLoading={loading}
        />
    
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message={
          <>
            {' '}
            <GetLabel label="activity" /> {form.getFieldValue('prcode')}
            <GetLabel label="exists" />
          </>
        }
        description={<GetLabel label="modifyActivity" />}
        onConfirm={() => {
          setModalVisible(false);
        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
    </Form>
  );
};

export default TabActivity;
